import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "EditOff"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 21.4425L2.5575 1.5L1.5 2.5575L9.0675 10.125L3 16.1925V21H7.8075L13.875 14.9325L21.4425 22.5L22.5 21.4425ZM7.1925 19.5H4.5V16.8075L10.125 11.1825L12.8175 13.875L7.1925 19.5ZM22.0575 4.6275L19.3725 1.9425C19.0912 1.66084 18.7094 1.50257 18.3113 1.50257C17.9132 1.50257 17.5314 1.66084 17.25 1.9425L11.19 8.0025L12.2475 9.06L15 6.3075L17.6925 9L14.94 11.7525L15.9975 12.81L22.0575 6.75C22.3392 6.46865 22.4975 6.08687 22.4975 5.68875C22.4975 5.29064 22.3392 4.90885 22.0575 4.6275ZM18.75 7.9425L16.0575 5.25L18.3075 3L21 5.6925L18.75 7.9425Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/EditOff.vue"]]);
